import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Header from '@bharatpe/bharat-ui/web/Header';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';
import history from 'utils/History';

interface AppHeaderProps {
	title: React.ReactElement | string;
	subTitle?: string;
	options?: React.ReactNode;
	children?: React.ReactNode;
	className?: string;
	leftIcon?: React.ReactNode;
	backActionToCloseDeepLink?: boolean;
	leftIconAction?: () => void;
	onRightIconAction?: () => void;
	backEventAction?: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({
	className,
	title,
	subTitle,
	children,
	leftIcon,
	backActionToCloseDeepLink,
	leftIconAction,
	options,
	backEventAction,
}) => {
	const dispatch = useDispatch();

	const goBack = useCallback(() => {
		backEventAction && backEventAction();
		if (backActionToCloseDeepLink) {
			NativeSupportHandlerV2.closeWebView();
		} else {
			if (leftIconAction) {
				leftIconAction();
			} else {
				if (window.history.length == 1) {
					NativeSupportHandlerV2.closeWebView();
				} else {
					history.go(-1);
				}
			}
		}
	}, [dispatch, leftIconAction]);

	return (
		<Header
			className={className}
			titleVariant="SemiBold400"
			title={title}
			subTitle={subTitle}
			leftIcon={leftIcon}
			leftIconAction={goBack}
			options={options}>
			{children}
		</Header>
	);
};

export default AppHeader;
